<template align="center">
    <el-table-body>
    <el-card shadow="never" class="aui-card--fill">
   <!-- <el-dialog :visible.sync="visible" :title="'年级成绩视图'"
               :close-on-click-modal="false" :close-on-press-escape="false"
    style="width: 2300px;align: center;"
    >-->
        <el-form :inline="true" :model="dataForm" >
            <el-select v-model="dataForm.gradeId" @keyup.enter.native="init()" placeholder="年级" @change="init" style="margin-left: 85%;margin-bottom: 20px">
                <el-option
                        v-for="grade in gradeList"
                        :key="grade.gradeId"
                        :label="grade.gradeName"
                        :value="grade.gradeId"></el-option>
            </el-select>
            <el-form-item prop="id" style="margin-left: 85%">
                <el-select v-model="dataForm.courseId" @keyup.enter.native="init()"  @change="init" clearable filterable>
                    <el-option  v-for="course in courseList" :label="course.courseName"
                               :value="course.courseId" :key="course.courseId" v-if="course.isMain == 1" aria-selected="true">
                    </el-option>
                </el-select>
            </el-form-item>
           <!-- <el-form-item>
                <el-button @click="init()">{{ $t('query') }}</el-button>
            </el-form-item>-->
        </el-form>

        <div>
            <el-button type="primary" size="small"   v-on:click="printOut('年级成绩视图')">导出PDF</el-button>
            <el-container style="margin-bottom: 30px">
                <el-main style="width: 60%;height: 100%"> <div id="chartColumn" style="width: 100%; height: 500px" ></div>
                </el-main>
                <el-main style="width: 40%">
                    <el-table  :data="dataList" border
                               style="width: 100%;">
                        <el-table-column prop="ranked" label="排行" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="className" label="班级名称" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="totalNumber" label="总人数" header-align="center" align="center"></el-table-column>
                       <!-- <el-table-column prop="totalScore" label="总分" header-align="center" align="center"></el-table-column>-->
                        <el-table-column prop="averageScore" label="平均分" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="teacherName" label="任课教师" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="historyRanked" label="历史排行" header-align="center" align="center">
                            <template slot-scope="scope">
                                <el-button  type="primary" size="small" @click="historyPage(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
            </el-container>
            <el-divider></el-divider>

           <!-- <el-container style="margin-bottom: 30px">
                <el-main style="width: 50%;height: 100%"> <div id="courseAverage" style="width: 100%; height: 400px" ></div>
                </el-main>
                <el-main style="width: 50%">
                    <el-table  :data="gradeDataList" border
                               style="width: 100%;"
                    >
                        <el-table-column prop="courseName" label="课程名称" header-align="center" align="center"></el-table-column>

                        <el-table-column prop="courseTotalNumber" label="总人数" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="courseTotalScore" label="总分" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="courseAverageScore" label="平均分" header-align="center" align="center"></el-table-column>

                    </el-table>
                </el-main>
            </el-container>
            <el-divider></el-divider>-->
            <el-container style="margin-bottom: 30px">
                <el-main style="width: 65%;height: 100%"> <div id="courseStatic" style="width: 100%; height: 500px" ></div>
                </el-main>
                <el-main style="width: 35%">
                    <el-table  :data="courseStaticList" border
                               style="width: 100%"
                    >
                        <el-table-column prop="className" label="班级名称" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="levelTotalNumber" label="总人数" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="excellent" label="优" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="good" label="良" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="pass" label="及格" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="fail" label="不及格" header-align="center" align="center"></el-table-column>

                    </el-table>
                </el-main>
            </el-container>
            <el-divider></el-divider>
            <el-container>
                <el-main style="width: 65%;height: 100%"> <div id="courseStaticRate" style="width: 100%; height: 500px" ></div>
                </el-main>
                <el-main style="width: 35%">
                    <el-table  :data="courseStaticList" border
                               style="width: 100%"
                    >
                        <el-table-column prop="className" label="班级名称" header-align="center" align="center"></el-table-column>

                        <el-table-column prop="excellentRate" label="优秀率" header-align="center" align="center"></el-table-column>

                        <el-table-column prop="passRate" label="合格率" header-align="center" align="center"></el-table-column>

                    </el-table>
                </el-main>
            </el-container>
               <!-- <div id="" style="width: 830px; height: 630px;margin-top: -20px" ></div>
        <div id="courseAverage" style="width: 630px; height: 500px;margin-top: 60px" ></div>
        <div id="courseStatic" style="width: 630px; height: 600px;margin-top: 50px" ></div>
        <div id="courseStaticRate" style="width: 650px; height: 600px;margin-top: 50px" ></div>-->

            <history-ranked v-if="historyVisible" ref="historyRanked"  @refreshDataList="getDataList()"></history-ranked>

        </div>
    <!--</el-dialog>-->
    </el-card>
    </el-table-body>
</template>

<script>
import * as echarts from 'echarts'
import HistoryRanked from './history-ranked'
import Template from '../devtools/template'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  name: 'evaluate-profile',
  components: { Template, HistoryRanked },
  data () {
    return {
      visible: false,
      dataForm: {
        courseId: '',
        gradeId: '',
        examId: ''
      },
      className: '',
      gradeList: [],
      grades: [],
      courseList: [],
      classList: [],
      courseStaticList: [],
      courseNameScoreList: [],
      courseNameList: [],
      courseAverageList: [],
      averageList: [],
      dataList: [],
      gradeDataList: [],
      excellentList: [],
      excellentRateList: [],
      goodList: [],
      passList: [],
      passRateList: [],
      failList: [],
      staticsList: [],
      profileList: [],
      historyVisible: false
    }
  },
  mounted () {
    // this.getCourse()
    this.init()
    // this.profilepicture()
  },
  methods: {
    printOut (name) {
      const shareContent = document.body; const // 需要截图的包裹的（原生的）DOM 对象
        width = shareContent.clientWidth // 获取dom 宽度
      const height = shareContent.clientHeight // 获取dom 高度
      const canvas = document.createElement('canvas') // 创建一个canvas节点
      const scale = 1 // 定义任意放大倍数 支持小数
      canvas.width = width * scale // 定义canvas 宽度 * 缩放
      canvas.height = height * scale - 200 // 定义canvas高度 *缩放
      canvas.style.width = shareContent.clientWidth * scale + 'px'
      canvas.style.height = shareContent.clientHeight * scale + 'px'
      canvas.getContext('2d').scale(scale, scale) // 获取context,设置scale
      const opts = {
        scale: scale, // 添加的scale 参数
        canvas: canvas, // 自定义 canvas
        logging: false, // 日志开关，便于查看html2canvas的内部执行流程
        width: width, // dom 原始宽度
        height: height,
        useCORS: true // 【重要】开启跨域配置
      }

      html2Canvas(shareContent, opts).then(() => {
        var contentWidth = canvas.width
        var contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89
        // 未生成pdf的html页面高度
        var leftHeight = contentHeight
        // 页面偏移
        var position = -30
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28
        var imgHeight = (592.28 / contentWidth) * contentHeight
        var pageData = canvas.toDataURL('image/jpeg', 1.0)
        var PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', -73, -30, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', -73, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(name + '.pdf') // 这里是导出的文件名
      })
    },
    historyPage (row) {
      this.historyVisible = true
      console.log(row.gradeList)
      this.$nextTick(() => {
        this.$refs.historyRanked.dataForm.classId = row.classId
        this.$refs.historyRanked.dataForm.courseId = this.dataForm.courseId
        this.$refs.historyRanked.init()
      })
    },
    init () {
      if (this.dataForm.examId === null || this.dataForm.examId === '') {
        this.dataForm.examId = this.$route.params.examId
        this.dataForm.gradeId = this.$route.params.gradeId
        this.gradeList = this.$route.params.gradeList
        this.dataForm.courseId = this.$route.params.courseId
      }
      this.visible = true
      this.classList = []
      this.averageList = []
      this.grades = []
      this.courseStaticList = []
      this.courseNameScoreList = []
      this.courseNameList = []
      this.courseAverageList = []
      this.averageList = []
      this.gradeDataList = []
      this.excellentList = []
      this.excellentRateList = []
      this.goodList = []
      this.passList = []
      this.passRateList = []
      this.failList = []
      this.staticsList = []
      this.profileList = []
      // console.log(this.dataList)
      // this.getGradeList()
      this.getCourse()
      if (this.dataForm.gradeId != null && this.dataForm.courseId != null && this.dataForm.courseId != '' && this.dataForm.gradeId != '') {
        //  console.log(this.dataForm)
        this.$http.get('/exam/examClass/getClassAverage/', {
          params: {
            gradeId: this.dataForm.gradeId,
            examId: this.dataForm.examId,
            courseId: this.dataForm.courseId
          }
        }).then(({ data: res }) => {
          //   console.log(this.dataForm)
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          //  console.log(res)
          this.dataList = res.data
          console.log(this.dataList)
          for (let i = 0; i < this.dataList.length; i++) {
            this.classList.push(this.dataList[i].className)
            this.averageList.push(this.dataList[i].averageScore)
          }
          // console.log(this.averageList)
          // console.log(res)
          this.profilepicture()
        }).catch(() => {
        })
      }
      /* this.$http.get('/exam/examClass/getGradeAverage/', {
        params: {
          gradeId: this.dataForm.gradeId,
          examId: this.dataForm.examId
        }
      }).then(({ data: res }) => {
        //   console.log(this.dataForm)
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        //  console.log(res)
        this.gradeDataList = res.data
        // console.log(this.dataList)
        for (let i = 0; i < this.gradeDataList.length; i++) {
          /!* var courseNameList = []
          courseNameList.push("text",this.gradeDataList[i].courseName)
          courseNameList.push("max",this.gradeDataList[i].courseTotal) *!/
          this.courseNameScoreList.push(this.gradeDataList[i].courseNameScore)
          this.courseAverageList.push(this.gradeDataList[i].courseAverageScore)
        }
        // console.log(this.courseNameScoreList[0])
        // console.log(this.averageList)
        // console.log(res)
        this.profileCourseAverage()
      }).catch(() => {
      }) */

      this.$http.get('/exam/examClass/getGradeStatics/', {
        params: {
          gradeId: this.dataForm.gradeId,
          examId: this.dataForm.examId,
          courseId: this.dataForm.courseId
        }
      }).then(({ data: res }) => {
        //   console.log(this.dataForm)
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.courseStaticList = res.data
        this.staticsList.push(this.courseStaticList[0].excellentName)
        this.staticsList.push(this.courseStaticList[0].goodName)
        this.staticsList.push(this.courseStaticList[0].passName)
        this.staticsList.push(this.courseStaticList[0].failName)
        for (let i = 0; i < this.courseStaticList.length; i++) {
          // 班级名称集合
          this.courseNameList.push(this.courseStaticList[i].className)
          /*    this.excellentList.push(this.courseStaticList[i].excellent)
          this.goodList.push(this.courseStaticList[i].good)
          this.passList.push(this.courseStaticList[i].pass)
          this.failList.push(this.courseStaticList[i].fail) */
          if (this.courseStaticList[i].excellent === 0) {
            this.excellentList.push('')
          } else {
            this.excellentList.push(this.courseStaticList[i].excellent)
          }
          if (this.courseStaticList[i].good === 0) {
            this.goodList.push('')
          } else {
            this.goodList.push(this.courseStaticList[i].good)
          }
          if (this.courseStaticList[i].pass === 0) {
            this.passList.push('')
          } else {
            this.passList.push(this.courseStaticList[i].pass)
          }
          if (this.courseStaticList[i].fail === 0) {
            this.failList.push('')
          } else {
            this.failList.push(this.courseStaticList[i].fail)
          }
          this.excellentRateList.push(this.courseStaticList[i].excellentRate)
          this.passRateList.push(this.courseStaticList[i].passRate)
        }

        this.profileCourseStatic()
        this.profileCourseStaticRate()
      }).catch(() => {
      })
    },
    profilepicture () {
      var chartDom = document.getElementById('chartColumn')
      var myChart = echarts.init(chartDom)
      myChart.setOption({
        title: {
          text: '主科班级平均分排行'
        },
        xAxis: {
          type: 'category',
          data: this.classList
        },
        yAxis: {
          type: 'value',
          name: '分数(分)'
        },
        series: [{
          data: this.averageList,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            valueAnimation: true
          }
        }]
      })
    },
    /*  profileCourseAverage () {
      var chartDom = document.getElementById('courseAverage')
      var myChart = echarts.init(chartDom)
      myChart.setOption({
        title: {
          text: '主科成绩平均分'
        },
        tooltip: {
          trigger: 'axis'
        },
        radar:
          {
            indicator: this.courseNameScoreList,
            center: ['35%', '50%'],
            radius: 120
          },
        series: [
          {
            type: 'radar',
            tooltip: {
              trigger: 'item'
            },
            areaStyle: {},
            data: [
              {
                value: this.courseAverageList,
                name: '主科成绩平均分'
              }
            ]
          }
        ]
      })
    }, */
    profileCourseStatic () {
      var chartDom = document.getElementById('courseStatic')
      var myChart = echarts.init(chartDom)
      myChart.setOption({
        title: {
          text: '优良统计'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          data: this.staticsList
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.courseNameList
        },
        yAxis: {
          type: 'value',
          name: '人数（个）'
        },
        series: [
          {
            name: this.staticsList[0],
            type: 'bar',
            stack: 'total',
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 16,
                  color: 'white'
                }
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.excellentList
          },
          {
            name: this.staticsList[1],
            type: 'bar',
            stack: 'total',
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 16,
                  color: 'white'
                }
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.goodList
          },
          {
            name: this.staticsList[2],
            type: 'bar',
            stack: 'total',
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 16,
                  color: 'white'
                }
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.passList
          },
          {
            name: this.staticsList[3],
            type: 'bar',
            stack: 'total',
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 16,
                  color: 'white'
                }
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.failList
          }
        ]
      })
    },
    profileCourseStaticRate () {
      var chartDom = document.getElementById('courseStaticRate')
      var myChart = echarts.init(chartDom)
      myChart.setOption({
        title: {
          text: '比率统计'
        },

        toolbox: {
          feature: {
            /* dataView: {show: true, readOnly: false},
            magicType: {show: true, type:  'bar'},
            restore: {show: true}, */
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['优秀率', '合格率']
        },
        xAxis: [
          {
            type: 'category',
            data: this.courseNameList,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis:
          {
            type: 'value',
            name: '比率',
            min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
              formatter: '{value}% '
            }
          },
        series: [
          {
            name: '优秀率',
            type: 'bar',
            data: this.excellentRateList,
            label: {
              normal: {
                show: true,
                position: 'top',
                formatter: '{c}%'
              }
            }

          },
          {
            name: '合格率',
            type: 'bar',
            data: this.passRateList,
            label: {
              normal: {
                show: true,
                position: 'top',
                formatter: '{c}%' // 数值显示百分比
              }
            }

          }
        ]
      })
    },

    /* getGradeList () {
      this.$http.get('/grade/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        var i = 0
        console.log(this.gradeList)
        for (i; i < res.data.length; i++) {
          if (this.gradeList[i].gradeId === res.data[i].id) {
            this.grades.push(res.data[i])
          }
        }
        // console.log(res.data)
      })
    }, */

    getCourse () {
      // eslint-disable-next-line no-template-curly-in-string
      this.$http.get('/exam/course/getCourseByExamId/' + this.dataForm.examId + '/' + this.dataForm.gradeId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        // console.log(res)
        this.courseList = res.data
        // console.log(this.courseList)
      }).catch(() => {})
    }
  }
}

</script>
